// Minimal footer variant for focused flows (e.g. get-started). Matches Figma
// node 205:8519: logo top-left, then a bottom row with legal links (left) and
// copyright (right). No link columns or socials. Text color uses `linen`
// (closest token to spec #FBF7F3).
import { useFocusActionState } from 'src/providers/FocusActionProvider'

import { Image } from 'src/components/atoms/Image'
import { InternalLink } from 'src/components/atoms/Link'

import { homePath, privacyPolicyPath, termsPath } from 'src/config/paths'

export const FooterRebrandMinimal = () => {
  const { isFocus } = useFocusActionState()

  if (isFocus) return null

  return (
    <footer className='w-full bg-wineRich text-linen'>
      <div className='container mx-auto flex flex-col gap-10 px-4 pt-16 pb-16 lg:gap-14 lg:px-20 lg:pt-20 lg:pb-20'>
        <InternalLink
          href={homePath}
          className='relative block h-[46px] w-[189px] max-w-full shrink-0 lg:h-[61px] lg:w-[252px]'
        >
          <Image
            fill
            alt='Trees That Count'
            src='/img/logos/ttc-logo-rebrand.svg'
            className='object-contain object-left'
          />
        </InternalLink>

        <div className='flex flex-col items-center gap-3 text-center font-body-rebrand text-base leading-[1.6] opacity-70 lg:flex-row lg:items-center lg:justify-between lg:text-left'>
          <div className='flex gap-3'>
            <InternalLink
              className='text-linen! hover:underline'
              href={privacyPolicyPath}
            >
              Privacy policy
            </InternalLink>
            <span aria-hidden>|</span>
            <InternalLink
              className='text-linen! hover:underline'
              href={termsPath}
            >
              Terms of use
            </InternalLink>
          </div>
          <span>
            &copy; {new Date().getFullYear()} Trees That Count, New Zealand
          </span>
        </div>
      </div>
    </footer>
  )
}

export default FooterRebrandMinimal
